<template>
  <div
    v-if="hasContent"
    :class="['ra-component-content', `ra-component-content--container-${containerType}`]"
  >
    <div class="ra-component-content__container">
      <div v-if="hasHeadingBlock" class="ra-component-content__heading-wrapper">
        <div v-if="caption" class="ra-component-content__caption">{{ caption }}</div>
        <component :is="headingLevel" v-if="title" class="ra-component-content__title">
          {{ title }}
        </component>
      </div>
      <div v-if="description" class="ra-component-content__description" v-html="description"></div>
      <div v-if="hasCta" class="ra-component-content__cta-wrapper">
        <a class="ra-component-content__cta" :href="ctaHref" v-bind="ctaAttrs">
          {{ ctaText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'refapp-hotspots-content',
  props: {
    caption: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    headingLevel: {
      type: String,
      default: 'h2',
    },
    description: {
      type: String,
      default: '',
    },
    ctaText: {
      type: String,
      default: '',
    },
    ctaHref: {
      type: String,
      default: '',
    },
    containerType: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'page'].includes(value);
      },
    },
    ctaAttrs: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasHeadingBlock() {
      return !!(this.caption || this.title);
    },
    hasCta() {
      return !!(this.ctaHref && this.ctaText);
    },
    hasContent() {
      return !!(this.caption || this.title || this.description || this.hasCta);
    },
  },
};
</script>

<style lang="scss">
@use 'styles.scss';
</style>
